
$(document).ready(function () {
    function createSnowflake() {
      const snowflake = $('<div class="snowflake">❄</div>');
      const startLeft = Math.random() * $(window).width();
      const endLeft = startLeft + (Math.random() * 100 - 50); // slight horizontal movement
      const duration = 5000 + Math.random() * 5000; // 5 to 10 seconds
      const size = 10 + Math.random() * 20;

      snowflake.css({
        left: startLeft,
        fontSize: size + 'px',
      });

      $('body').append(snowflake);

      snowflake.animate({
        top: '100%',
        left: endLeft + 'px',
        opacity: 0.2
      }, duration, 'linear', function () {
        $(this).remove();
      });
    }

    // Generate a snowflake every 300 ms
    setInterval(createSnowflake, 300);
  });